import { StatusChip } from '@/components/common/StatusChip';
import type { Domain } from '@/features/domains/types';

export function DomainStatusChip({ domain }: { domain: Domain }) {
  if (domain.status === 'suspended') return <StatusChip tone="danger">Suspended</StatusChip>;
  if (!domain.verified) return <StatusChip tone="warning">Unverified</StatusChip>;
  return <StatusChip tone="success">Active</StatusChip>;
}
